import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Heading
} from "@chakra-ui/react"
import Pathicon from "@pathwright/web/src/modules/pathicon/Pathicon"
import { useRouteMatch } from "react-router-dom"
import Link from "../link/Link"
import {
  AugmentationToolbarDropdown,
  AugmentationToolbarHookReturn,
  AugmentationToolbarOptionNode
} from "./AugmentationToolbar"

function AugmentationToolbarBreadcrumb({
  toolbar,
  option
}: {
  toolbar: AugmentationToolbarHookReturn
  option: AugmentationToolbarOptionNode
}) {
  const index = toolbar.stack.indexOf(option)
  const isLast = index === toolbar.stack.length - 1
  // Form the route to match based on the toolbar stack up to this option.
  const route = `/${toolbar.stack
    .slice(0, index + 1)
    .map((o) => o.key)
    .join("/")}/`
  // We can use the match.url to route to this toolbar option.
  const match = useRouteMatch(route)

  return match ? (
    <Link
      as={BreadcrumbLink}
      to={match.url}
      color="black"
      isCurrentPage={isLast}
      underlineBehavior={isLast ? "never" : "hover"}
      cursor={isLast ? "default" : "pointer"}
      onClick={(e) => {
        if (isLast) e.preventDefault()
      }}
      minW={0}
    >
      <Heading
        as="h2"
        size="h6"
        className="theme-heading theme-heading-bold"
        fontWeight="bold"
      >
        {option.AugmentationLabelComponent ? (
          <option.AugmentationLabelComponent match={match} />
        ) : (
          option.label
        )}
      </Heading>
    </Link>
  ) : null
}

// TODO: handle overflow of breadcrumbs. Not necessary right now as
// we only have a max depth of 2 in the home augmentation.
function AugmentationToolbarBreadcrumbs(
  toolbar: AugmentationToolbarHookReturn
) {
  return toolbar.stack.length > 1 ? (
    <Breadcrumb
      p={1}
      separator={<Pathicon icon="chevron-right" />}
      spacing={1}
      sx={{
        ["[role='presentation']"]: {
          display: "flex"
        }
      }}
    >
      {toolbar.stack.map((option) => (
        <BreadcrumbItem spacing={0} key={option.key}>
          <AugmentationToolbarBreadcrumb toolbar={toolbar} option={option} />
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  ) : (
    <AugmentationToolbarDropdown {...toolbar} />
  )
}

export default AugmentationToolbarBreadcrumbs
